export const getFilename = (filename: string) => {
  const [url] = filename.split('?')
  const result = url.split('/')

  return decodeURIComponent(result[result.length - 1])
}

export default getFilename
